import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core';


const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            textAlign: "center",
            padding: 12,
            whiteSpace: "nowrap",
            '& > *': {
                margin: theme.spacing(1),
                // borderRadius: "20px",
                fontSize: "1.2em",
                minWidth: 90,
            },
        },
    }),
);

export const ButtonBar = props => {
    const classes = useStyles();
    return <div className={classes.root} {...props}>{props.children}</div>
}